import { prop } from '@solta/ramda-extra'
import { userAdapter } from './module'

const selectUsers = prop('user')

export const { selectAll: selectAllUsers } = userAdapter.getSelectors(selectUsers)
